export default "__VITE_PUBLIC_ASSET__48eda1bc__"